import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import React from 'react';
import reactCSS from 'reactcss';
import ChromeFields from 'react-color/lib/components/chrome/ChromeFields';
import { CustomPicker } from 'react-color';
import Icon from '../../../../core/Icon';
import { Hue, Saturation, Checkboard } from 'react-color/lib/components/common';

var Picker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Picker, _React$Component);

  function Picker() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Picker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Picker)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleClearClick = function () {
      _this.props.onChange('transparent');
    };

    return _this;
  }

  _createClass(Picker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hex = _this$props.hex,
          rgb = _this$props.rgb,
          hsl = _this$props.hsl,
          hsv = _this$props.hsv,
          onChange = _this$props.onChange,
          renderers = _this$props.renderers,
          disableAlpha = _this$props.disableAlpha;
      var styles = reactCSS({
        default: {
          picker: {
            background: '#fff',
            borderRadius: '2px',
            boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
            boxSizing: 'initial',
            width: '225px'
          },
          saturation: {
            width: '100%',
            paddingBottom: '55%',
            position: 'relative',
            borderRadius: '2px 2px 0 0',
            overflow: 'hidden'
          },
          Saturation: {
            radius: '2px 2px 0 0'
          },
          body: {
            padding: '16px 16px 12px'
          },
          controls: {
            display: 'flex'
          },
          reset: {
            fontSize: '16px',
            cursor: 'pointer',
            width: '16px',
            height: '16px'
          },
          resetButton: {
            backgroundColor: 'inherit',
            border: 'none',
            outline: 'none',
            paddingLeft: '0px'
          },
          color: {
            width: '16px',
            marginTop: '3px'
          },
          swatch: {
            width: '10px',
            height: '10px',
            borderRadius: '8px',
            position: 'relative',
            overflow: 'hidden'
          },
          active: {
            absolute: '0px 0px 0px 0px',
            borderRadius: '8px',
            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
            background: "rgba(".concat(rgb.r, ", ").concat(rgb.g, ", ").concat(rgb.b, ", ").concat(rgb.a, ")"),
            zIndex: '2'
          },
          toggles: {
            flex: '1'
          },
          hue: {
            height: '10px',
            position: 'relative',
            marginBottom: '8px',
            marginTop: '3px'
          },
          Hue: {
            radius: '2px'
          },
          alpha: {
            height: '10px',
            position: 'relative'
          },
          Alpha: {
            radius: '2px'
          }
        },
        disableAlpha: {
          color: {
            width: '22px'
          },
          alpha: {
            display: 'none'
          },
          hue: {
            marginBottom: '0px'
          }
        }
      }, {
        disableAlpha: disableAlpha
      });
      return React.createElement("div", {
        style: styles.picker
      }, React.createElement("div", {
        style: styles.saturation
      }, React.createElement(Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
      })), React.createElement("div", {
        style: styles.body
      }, React.createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
      }, React.createElement("div", null, React.createElement("button", {
        onClick: this.handleClearClick,
        style: styles.resetButton
      }, React.createElement(Icon, {
        style: styles.reset,
        disabled: false,
        hoverable: true,
        type: "clear",
        label: "Clear color"
      }))), React.createElement("div", {
        style: styles.color
      }, React.createElement("div", {
        style: styles.swatch
      }, React.createElement("div", {
        style: styles.active
      }), React.createElement(Checkboard, {
        renderers: renderers
      }))), React.createElement("div", {
        style: styles.toggles
      }, React.createElement("div", {
        style: styles.hue
      }, React.createElement(Hue, {
        style: styles.Hue,
        hsl: hsl,
        onChange: onChange
      })))), React.createElement(ChromeFields, {
        rgb: rgb,
        hsl: _objectSpread({}, hsl, {
          a: 0.9
        }),
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
      })));
    }
  }]);

  return Picker;
}(React.Component);

export default CustomPicker(Picker);